import React from "react";
import {
  Box,
  Button,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ConfirmModal } from "../ConfirmModal";

interface ApproveRejectModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (actionType: "approve" | "reject", comment?: string) => void;
  actionType: "approve" | "reject" | null;
  isSubmitting: boolean;
  comment: string;
  setComment: React.Dispatch<React.SetStateAction<string>>;
}

export const ApproveRejectModal: React.FC<ApproveRejectModalProps> = ({
  open,
  onClose,
  onSubmit,
  actionType,
  isSubmitting,
  comment,
  setComment,
}) => {
  const { t } = useTranslation();

  const isReject = actionType === "reject";
  const title = isReject
    ? t("Motivo del rechazo")
    : t("Confirmar aprobación");
  const description = isReject
    ? t("Por favor, indique el motivo por el cual rechaza la cotización dada.")
    : t("Por favor, indique el motivo por el cual aprueba la cotización dada.");
  const buttonText = isReject
    ? t("Rechazar cotización")
    : t("Aprobar cotización");
  const buttonColor = isReject ? "#EC6666" : "#4A01C4";

  const handleClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
    if (reason !== "backdropClick") {
      onClose();
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: 400, sm: 600, md: 500, lg: 650 },
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography id="modal-title" variant="h6" component="h2" textAlign={"center"}>
            {title}
          </Typography>
          <Typography id="modal-description" sx={{ mt: 2 }} textAlign={"center"}>
            {description}
          </Typography>
          <TextField
            fullWidth
            label={t("Comentario")}
            variant="outlined"
            multiline
            rows={4}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            sx={{ mt: 2 }}
            inputProps={{ maxLength: 255 }}
          />
          <Box display="flex" justifyContent="space-between" mt={3}>
            <Button onClick={onClose}>{t("Cancelar")}</Button>
            <Button
              variant="contained"
              sx={{ backgroundColor: buttonColor, "&:hover": { backgroundColor: buttonColor } }}
              onClick={() => onSubmit(actionType!, comment)}
              disabled={isSubmitting || comment.trim() === ""}
            >
              {buttonText}
            </Button>
          </Box>
        </Box>
      </Modal>
      <ConfirmModal />
    </>
  );
};